// extracted by mini-css-extract-plugin
module.exports = {"input":"Signin_input__3TbF-","forgot":"Signin_forgot__3G2er"};